import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FormCol, sqlDateTimeUtcStr } from 'motion-components';
import * as Yup from 'yup';
import { SelectMonth } from '../../components/select-month';
import { SelectYear } from '../../components/select-year';
import { useTranslation } from 'react-i18next';
import { splitGmtFromDate } from 'motion-components';
import { useRootStore } from 'store';
import { FieldSelectCollector } from 'shared-pages/components';

/* ----------- Filters ------------------ */
export const Filters = ({ onChange, initialValues }) => {
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      const startDate = values.month
        ? new Date(values.year, values.month - 1, 1)
        : new Date(values.year, 0, 1);

      const endDate = values.month
        ? new Date(values.year, values.month, 0, 23, 59, 59)
        : new Date(values.year, 11, 31, 23, 59, 59);

      onChange({
        startDate: splitGmtFromDate(startDate),
        endDate: splitGmtFromDate(endDate),
        collectorId: values.collectorId,
      });
    }, 400);
  }

  const filters = {
    month: initialValues?.month ?? undefined,
    year: initialValues?.year ?? new Date().getFullYear(),
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const formShape = {
    month: Yup.string(),
    year: Yup.string().required('Το Έτος είναι υποχρεωτικό'),
    collectorId: Yup.number().nullable(),
  };

  const validationSchema = Yup.object().shape(formShape);
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      validationSchema={validationSchema}
    >
      <Row>
        <SelectYear name="year" title="Έτος" required={true} as={FormCol} />
        <SelectMonth name="month" title="Μήνας" required={true} as={FormCol} />
        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
      </Row>
    </FormFilterCard>
  );
};
